import _isEmpty from 'lodash/isEmpty';

const namePattern = /^[a-z-'\s]+$/i;
const emailPattern = /^[a-zA-Z\-0-9](([^<>()[\]\\.,;:\s@"]*(\.[^<>()[\-\].,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9](?:[a-zA-Z0-9]|-(?!-))*\.)+[a-zA-Z]{2,}))$/;
const phonePattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
const securityAnswerPattern = /^([a-zA-Z0-9])+([ '-][a-zA-Z0-9]+)*$/;
const noSpecialChars = /^[a-z0-9]+$/i;
export function getRequiredAlertText(field) {
    return _isEmpty(field) ? 'This field is required.' : '';
}

export function getNamePatternAlertText(field) {
    return namePattern.test(field) ? '' : 'This field must use letters only.';
}

export function getMinlengthAlertText(field, minlength) {
    return field?.length >= minlength
        ? ''
        : `This field must be ${minlength} characters or longer.`;
}

export function getMaxlengthAlertText(field, maxlength) {
    return field?.length <= maxlength
        ? ''
        : `This field must be ${maxlength} characters or shorter.`;
}

export function getNoSpecialCharsAlertText(field) {
    return noSpecialChars.test(field) ? '' : 'Special characters are not allowed.';
}

export function getEmailPatternAlertText(field) {
    return emailPattern.test(field) ? '' : 'Email address format is invalid.';
}

export function getPhonePatternAlertText(field) {
    return phonePattern.test(field) ? '' : 'Phone number must be 10 digits.';
}

export function getPassInvalidWordAlertText(field) {
    return field.toLowerCase().indexOf('password') === -1
        ? ''
        : 'Password cannot include the word "password".';
}

export function getPassIsUserIdAlertText(password, id) {
    return password !== id ? '' : 'Password cannot be the same as your User ID';
}

export function getPassRulesInvalidAlertText(validPassword) {
    return validPassword === false ? 'Password rules are not met.' : '';
}

export function getSecuritySpecialCharsAlertText(field) {
    return securityAnswerPattern.test(field)
        ? ''
        : 'Answer cannot contain special characters other than "-".';
}
